import { request, getApiUrl } from '@/utils/ajax';
import { ProjectCatalogProduct, ProductFile, CatalogFilterData } from '@/types';

export function saveProjectCatalogProduct(
    product: Partial<ProjectCatalogProduct>,
    files: ProductFile[]
): Promise<ProjectCatalogProduct> {
    return request(`api/project-catalog-product`, {
        method: 'POST',
        json: true,
        body: {
            product,
            files,
        },
    }).then((x) => x.json());
}

export function deleteProjectCatalogProduct(catalogProductId: number) {
    return request(`api/project-catalog-product/${catalogProductId}`, {
        method: 'DELETE',
    });
}

export function getProjectCatalogProduct(productId: number): Promise<ProjectCatalogProduct> {
    return request(`api/project-catalog-product/${productId}`).then((x) => x.json());
}

export function getProjectCatalogFilters(projectId: number): Promise<CatalogFilterData> {
    return request(`api/project-catalog-product/filter-data`, {
        query: { projectId },
    }).then((x) => x.json());
}

export interface ProjectCatalogProductsSearchOptions {
    projectId: number;
    searchText?: string | null;
    itemCategoryIds?: number[] | null;
    ownerProfileId?: number;
    suppliers?: string[] | null;
}

export function searchProjectCatalogProducts(
    options: ProjectCatalogProductsSearchOptions
): Promise<ProjectCatalogProduct[]> {
    return request(`api/project-catalog-product`, {
        query: options,
    }).then((x) => x.json());
}

// When `showroomPath` is provided, the URL points at the anonymous showroom-scoped image
// endpoint that re-validates the path components and that the image belongs to the same
// project as the resolved unit. Without `showroomPath`, returns the auth-gated
// /api/project-catalog-product-file URL.
export function getProjectCatalogProductFileUrl(
    productImageId: number,
    options?: { download?: boolean; showroomPath?: string | null }
) {
    if (options?.showroomPath) {
        return `${getApiUrl()}/api/showroom/${options.showroomPath}/product-image/${productImageId}`;
    }
    return `${getApiUrl()}/api/project-catalog-product-file/${productImageId}/${options?.download ? 'download' : 'open'}`;
}

export function getProjectCatalogProductFileThumbnailUrl(
    productImageId: number,
    options?: { showroomPath?: string | null }
) {
    if (options?.showroomPath) {
        return `${getApiUrl()}/api/showroom/${options.showroomPath}/product-image/${productImageId}/thumbnail`;
    }
    return `${getApiUrl()}/api/project-catalog-product-file/${productImageId}/thumbnail`;
}